export default "__VITE_ASSET__bcc26894__"